import { Box, styled } from '@mui/joy'

export const LocaleWrapper = styled(Box)`
  position: absolute;
  right: 0;
  bottom: 6px;
  width: 140px;
`
